module.exports = __webpack_public_path__ + "media/images/map-bg-4f99e39a2ea88a375e2da0116b171f54.png";